query TestBaseData($runId: ConditionID!) {
	wsdk_test_runs(run_id_eq: $runId) {
		test_name
		run_time
	}
}
